import axios from 'axios';
import store from '../store/index.js';

const instance = axios.create({
    baseURL: `${import.meta.env.VITE_API_ROOT}/api`,
    withCredentials: true,
});

instance.interceptors.request.use((config) => {
    // Ensure headers object exists
    config.headers = config.headers || {};

    // Only add token if Authorization header is not already set (for retries)
    if (! config.headers['Authorization']) {
        const token = store.getters['session/accessToken'];

        if (token !== null) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
    }

    config.timeout = 30000;

    return config;
});

export default instance;
